// extracted by mini-css-extract-plugin
export default {"content":"style_content__CQ-Y0","leftSide":"style_leftSide__2bRCq","rightSide":"style_rightSide__6+zx-","type":"style_type__lu7IX"};